interface CustomEventData {
  [key: string]: unknown
}

export type SendCustomEventFunction = (eventName: string, data?: CustomEventData) => void

export const sendCustomEvent: SendCustomEventFunction = (eventName, data = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, data)
  } else {
    console.error('gtag function is not defined on the window')
  }
}
